import React, { useEffect, useState } from 'react';
import { Input, } from 'antd';
import { ShippingNamesProps } from '../interfaces';
import './shippingNames.scss';

const ShippingNames: React.FC<ShippingNamesProps> = ({
    initialFirstName,
    initialLastName,
    onUpdate,
    updateButtonClicked
}) => {
    const [firstName, setFirstName] = useState(initialFirstName);
    const [lastName, setLastName] = useState(initialLastName);
    const [isFirstNameTouched, setIsFirstNameTouched] = useState(false);
    const [isLastNameTouched, setIsLastNameTouched] = useState(false);
    const [errors, setError] = useState<{ firstName: boolean, lastName: boolean }>({
        firstName: false,
        lastName: false,
    });

    const [prevUpdateClicked, setPrevUpdateClicked] = useState(false);

    useEffect(() => {
        setFirstName(initialFirstName);
        setLastName(initialLastName);
    }, [initialFirstName, initialLastName]);

    useEffect(() => {
        const hasFirstNameError = isFirstNameTouched && !firstName.trim();
        const hasLastNameError = isLastNameTouched && !lastName.trim();
        setError({
            firstName: hasFirstNameError,
            lastName: hasLastNameError,
        });
    }, [firstName, lastName, isFirstNameTouched, isLastNameTouched]);

    useEffect(() => {
        if (updateButtonClicked && !prevUpdateClicked) {
            const hasFirstNameError = !firstName.trim();
            const hasLastNameError = !lastName.trim();
            setError({
                firstName: hasFirstNameError,
                lastName: hasLastNameError,
            });
            onUpdate({
                firstName,
                lastName,
            });
            setPrevUpdateClicked(true);
        } else if (!updateButtonClicked) {
            setPrevUpdateClicked(false);
        }
    }, [updateButtonClicked, prevUpdateClicked, firstName, lastName, onUpdate]);

    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFirstName(value);
        setIsFirstNameTouched(true);
        onUpdate({ firstName: value, lastName });
    };

    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLastName(value);
        setIsLastNameTouched(true);
        onUpdate({ firstName, lastName: value });
    };

    return (
        <div className="shipping-info">
            <div className="input-container">
                <label htmlFor="firstName" className="input-label">First Name</label>
                <Input
                    id="firstName"
                    name="firstName"
                    className={`name-input ${errors.firstName ? 'error' : ''}`}
                    value={firstName}
                    onChange={handleFirstNameChange}
                    status={errors.firstName ? 'error' : undefined}
                />
            </div>
            <div className="input-container">
                <label htmlFor="lastName" className="input-label-second">Last Name</label>
                <Input
                    id="lastName"
                    name="lastName"
                    className={`name-input ${errors.lastName ? 'error' : ''}`}
                    value={lastName}
                    onChange={handleLastNameChange}
                    status={errors.lastName ? 'error' : undefined}
                />
            </div>
        </div>
    );
};

export default ShippingNames;
